export default __webpack_public_path__ + "static/media/eating.3e81a117.svg";